import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alert-badge" }

import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { computed } from 'vue';
import { DashboardAlertType } from '../domains/entities/DashboardAlert';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardAlertBadge',
  props: {
    alert: { default: undefined },
    severity: {},
    withIconName: { default: undefined }
  },
  setup(__props: any) {

/**
 * 発注ステータスバッジ
 */
const props = __props;
const t = i18n.t;

const alertLabelName = computed(() => (props.alert?.includes('forecast_sharp') ? `${props.severity}_${props.alert}` : props.alert));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`status-tag status-tag--${alertLabelName.value}`)
    }, [
      _createElementVNode("span", null, _toDisplayString(alertLabelName.value ? _unref(t)(alertLabelName.value) : ''), 1),
      (props.withIconName)
        ? (_openBlock(), _createBlock(Mdi, {
            key: 0,
            icon: props.withIconName,
            class: "status-tag__icon"
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})